import gql from "graphql-tag";

export const MY_HR_CHANGE_PASSWORD = gql`
  mutation changePassword(
    $email: String!
    $oldPassword: String!
    $newPassword: String!
  ) {
    changePassword(
      email: $email
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      status
      statusMessage
    }
  }
`;
